/**
 * @generated SignedSource<<6fcb8c4341af8f4702b9967fca78e9e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CopyArticleInput = {
  baseId?: string | null;
  clientMutationId?: string | null;
};
export type CopyArticleMutation$variables = {
  input: CopyArticleInput;
};
export type CopyArticleMutation$data = {
  readonly copyArticle: {
    readonly article: {
      readonly rowId: string;
    } | null;
  } | null;
};
export type CopyArticleMutation = {
  response: CopyArticleMutation$data;
  variables: CopyArticleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CopyArticleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CopyArticlePayload",
        "kind": "LinkedField",
        "name": "copyArticle",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Article",
            "kind": "LinkedField",
            "name": "article",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CopyArticleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CopyArticlePayload",
        "kind": "LinkedField",
        "name": "copyArticle",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Article",
            "kind": "LinkedField",
            "name": "article",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "52ddbe8e95681287e49cdde354285074",
    "id": null,
    "metadata": {},
    "name": "CopyArticleMutation",
    "operationKind": "mutation",
    "text": "mutation CopyArticleMutation(\n  $input: CopyArticleInput!\n) {\n  copyArticle(input: $input) {\n    article {\n      rowId\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0ab4c6846634ddf09499af533de963a6";

export default node;
